import { signOut } from "firebase/auth";
import React from "react";
import { FaBell, FaCog, FaSignOutAlt, FaUser, FaWallet } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { fAuth } from "../firebase";

const Header = () => {
  const navigate = useNavigate();

  function handeLogout() {
    signOut(fAuth);
  }

  return (
    <header className="bg-gray-900/95 backdrop-blur-md text-white px-3 sm:px-6 py-3 flex items-center justify-between fixed w-full top-0 z-50 border-b border-gray-800">
      {/* Logo & Wallet Section */}
      <div className="flex items-center gap-3 sm:gap-6">
        <img
          src="/Group 6.png"
          alt="CR11"
          className="h-8 sm:h-10 w-auto cursor-pointer hover:opacity-80 transition-opacity"
        />
        <div className="hidden sm:flex items-center bg-gray-800/50 hover:bg-gray-800 transition-all rounded-lg px-3 py-1.5 border border-gray-700/50 hover:border-gray-700 cursor-pointer group">
          <FaWallet className="text-blue-500 group-hover:text-blue-400 mr-2" />
          <span className="text-sm font-medium">₹764.19</span>
        </div>
      </div>

      {/* Mobile Wallet & Notification */}
      <div className="flex items-center gap-4 sm:hidden">
        <div className="flex items-center bg-gray-800/50 rounded-lg px-2 py-1">
          <FaWallet className="text-blue-500 text-sm" />
          <span className="text-xs font-medium ml-1">₹764</span>
        </div>
      </div>

      {/* Desktop Menu */}
      <div className="hidden sm:flex items-center gap-5">
        {/* <div className="flex items-center gap-3 sm:gap-4">
          <button
            onClick={() => navigate("/account")}
            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-500 px-3 sm:px-4 py-1.5 rounded-lg transition-all text-sm font-medium"
          >
            <FaUser className="text-sm" />
            <span>Account</span>
          </button>
          <FaCog className="text-lg text-gray-400 hover:text-white cursor-pointer transition-colors" />
          <FaSignOutAlt
            onClick={handeLogout}
            className="text-lg text-gray-400 hover:text-white cursor-pointer transition-colors"
          />
        </div> */}
      </div>
    </header>
  );
};

export default Header;
